import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { RouteData } from './main/sidebar/navigation.model';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { AuthenticationGuard } from './core';

import { PaymentHistoryComponent } from './main/payment-history/payment-history.component';
import { ComplaintComponent } from './auth/complaint/complaint.component';
import { FaqComponent } from './auth/faq/faq.component';
import { ContactUsComponent } from './auth/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './auth/privacy-policy/privacy-policy.component';
import { NotFoundComponent } from './auth/not-found/not-found.component';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { ProfileComponent } from './auth/profile/profile.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { RefundPolicyComponent } from './auth/refund-policy/refund-policy.component';
import { TermsComponent } from './auth/terms/terms.component';
import {CompanyDashboardComponent} from './company-registration/company-dashboard/company-dashboard.component';


const routes: Routes = [
  {
    path: '',
    // component: LoginLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/login'
      },
      {
        path: 'home',
        component: LoginComponent,
        data: {
          title: 'Data-Entry LogIn',
          breadcrumbs: [
            {
              text: 'Data-Entry Home',
              active: true
            }
          ],
        } as RouteData,
      }
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login | CAC Data-Entry',
      breadcrumbs: [
        {
          text: 'Home',
          link: '/'
        },
        {
          text: 'Login | CAC Data-Entry',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    data: {
      title: 'Reset Login Password | CAC Data-Entry',
      breadcrumbs: [
        {
          text: 'Home',
          link: '/'
        },
        {
          text: 'Reset Login Password | CAC Data-Entry',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'change-password',
    canActivate: [AuthenticationGuard],
    component: ChangePasswordComponent,
    data: {
      title: 'Change Password | CAC Data-Entry',
      breadcrumbs: [
        {
          text: 'Pre-Incorporation Dashboard',
          link: '/dashboard'
        },
        {
          text: 'Change Password | CAC Data-Entry',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'edit-profile',
    canActivate: [AuthenticationGuard],
    component: ProfileComponent,
    data: {
      title: 'Edit Profile | CAC Data-Entry',
      breadcrumbs: [
        {
          text: 'Pre-Incorporation Dashboard',
          link: '/dashboard'
        },
        {
          text: 'Edit Profile | CAC Data-Entry',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'dashboard',
    canActivate: [AuthenticationGuard],
    component: DashboardComponent,
    data: {
      title: 'Data-Entry Dashboard',
      breadcrumbs: [
        {
          text: 'Data-Entry Login',
          link: '/login'
        },
        {
          text: 'Data-Entry Dashboard',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'company-dashboard',
    canActivate: [AuthenticationGuard],
    component: CompanyDashboardComponent,
    data: {
      title: 'Company Dashboard',
      breadcrumbs: [
        {
          text: 'Data-Entry Login',
          link: '/company-dashboard'
        },
        {
          text: 'Data-Entry Dashboard',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'complaint',
    component: ComplaintComponent,
    data: {
      title: 'Corporate Affairs Commision - Complaint',
      breadcrumbs: [
        {
          text: 'Home',
          link: '/'
        },
        {
          text: 'Complaint',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'faq',
    component: FaqComponent,
    data: {
      title: 'Corporate Affairs Commision - FAQ',
      breadcrumbs: [
        {
          text: 'Home',
          link: '/'
        },
        {
          text: 'FAQ',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    data: {
      title: 'Corporate Affairs Commision - Contact Us',
      breadcrumbs: [
        {
          text: 'Home',
          link: '/'
        },
        {
          text: 'Contact Us',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
    data: {
      title: 'Corporate Affairs Commision - Contact Us',
      breadcrumbs: [
        {
          text: 'Home',
          link: '/'
        },
        {
          text: 'Privacy Policy',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'refund-policy',
    component: RefundPolicyComponent,
    data: {
      title: 'Corporate Affairs Commision - Contact Us',
      breadcrumbs: [
        {
          text: 'Home',
          link: '/'
        },
        {
          text: 'Refunds, Cancellation and Return Policy',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'terms',
    component: TermsComponent,
    data: {
      title: 'Corporate Affairs Commision - Contact Us',
      breadcrumbs: [
        {
          text: 'Home',
          link: '/'
        },
        {
          text: 'Terms and Conditions',
          active: true
        }
      ],
    } as RouteData,
  },
  {
    path: 'payment-history',
    component: PaymentHistoryComponent,
    data: {
      title: 'Payment History | CAC Pre-Inc Processes',
      breadcrumbs: [
        {
          text: 'Payment History | CAC Pre-Inc Processes',
          active: true
        }
      ],
    } as RouteData,
  },
  // {
  //   path: 'register',
  //   loadChildren: () => import('./user-registration/user-registration/user-registration.module').then(res => res.UserRegistrationModule),
  // },
  {
    path:'post-incorporation',
    loadChildren: () =>import('./company-update/company-update.module').then(m => m.CompanyUpdateModule)
  },
  // // {
  // //   path: 'name-reservation',
  // //   loadChildren: () => import('./name-reservation/name-reservation.module').then(m => m.NameReservationModule),
  // // },
  {
    path: 'company-registration',
    loadChildren: () => import('./company-registration/company-registration.module').then(res => res.CompanyRegistrationModule)
  },
  { path: 'escalated-application',
  loadChildren: () => import('./escalated-application/escalated-application.module').then(m => m.EscalatedApplicationModule) },

  {path: '**',
  component: NotFoundComponent}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
